import React, { useState, useContext, useRef, useEffect, useMemo, memo } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { styles, navigateToCell, startsWithFilter } from "./shared.js";
import "./Renderables.css";

const handleLocationOnEnter = (index) => {
  const nextBusInput = document.getElementById(`lastVehicle-${index + 1}`);
  const targetElement = nextBusInput.querySelector("div > div > div > input");

  if (targetElement) {
    targetElement.focus();
  }
};

export const RenderLocationEditable = memo(({
  value: initialValue,
  row,
  rowCount,
  column,
  onCellInputBlur,
  TableContext,
  viewOnly,
}) => {
  const locationsData = useContext(TableContext);
  const { index } = row;
  const { id } = column;
  const finalRow = index === rowCount - 1;
  const deleteKeys = ["BACKSPACE", "DELETE"];
  const locationOptions = useMemo(
    () => locationsData.locations.map((member) => ({
      label: member.slot,
      value: member.slot,
    })),
    [locationsData.locations]
  );
  const [optionListIsOpen, setOptionListIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(initialValue);
  const selectLocationRef = useRef(null);

  useEffect(() => {
    setSelectedValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (optionListIsOpen) {
      const optionList = document.querySelector(`[role="listbox"]`);
      if (optionList) {
        // Calculate the position of the listbox bottom relative to the viewport
        if (optionList.getBoundingClientRect().bottom > window.innerHeight) {
          optionList.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
        }
      }
    }
  }, [optionListIsOpen]);

  return (
    <Select
      ref={selectLocationRef}
      placeholder={""}
      value={
        selectedValue ? { label: selectedValue, value: selectedValue } : null
      }
      options={locationOptions}
      isDisabled={viewOnly}
      filterOption={startsWithFilter}
      name="carss"
      myFontSize="5px"
      id={`${id}-${index}`}
      styles={styles}
      onMenuOpen={() => setOptionListIsOpen(true)}
      onMenuClose={() => setOptionListIsOpen(false)}
      onChange={(e) => {
        setSelectedValue(e.value);
        onCellInputBlur(e.value, index, id, row);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" && !finalRow) {
          handleLocationOnEnter(index);
        } else if (deleteKeys.includes(e.key.toUpperCase())) {
          if (!e.target.value) {
            setSelectedValue("");
            onCellInputBlur("", index, id, row);
          }
        } else if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
          e.preventDefault();
          navigateToCell(id, index, e.key, rowCount);
        }
      }}
    />
  );
});

RenderLocationEditable.displayName = "RenderLocationEditable";

RenderLocationEditable.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    index: PropTypes.number.isRequired,
  }).isRequired,
  rowCount: PropTypes.number.isRequired,
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onCellInputBlur: PropTypes.func.isRequired,
  TableContext: PropTypes.object.isRequired,
  viewOnly: PropTypes.bool.isRequired,
};
